import React, { useCallback, useEffect, useMemo, useState } from "react";
import Errors from "../../constants/Errors.json";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";

import variables from "../../constants/assets/variables";
import NoFooterModal from "../Common/NoFooterModal";
import {
  BottomSectionModal,
  NotesSection,
  UploadCsvOption,
} from "../../constants/assets/containers";
import FileUpload from "../Common/FileUpload";
import InformationBar from "../Common/InformationBar";
import Button from "sushiweb/Button";
import * as UserActions from "../../store/actions/User";
import PaginatedReactDropdown from "../Common/PaginatedReactDropdown";

const BulkUploadFile = ({
  instructions, //set of instructions or note
  sampleURL, //sample url of file to download
  filename, //filename to be send in payload
  setStatus,
  setUploadedFileName,
  setActiveFilePath,
  heading, //heading of the modal
  id, //id of the modal (mandatory field)
  btnDataTestID, //data-testid of confirm button (mandatory field for testing)
  keyName, //keyName of the key to be send in acknowledgement
  uploadUrl, //upoadUrl is the url on which the ack will be sent
  sendExtraAck, //pass boolean value if to pass filepath as extra param or not in ack call
  getUploadUrl, //function for api call
  closeUrl, // url where it should redirect when closed
  customHandleClose, // pass function if want to handle modal close by yourself
  useUserUploadedFilename, // pass boolean value if to use filename of file uploaded by user or not
  filterTypes = [], // array of values for filtering
  filterTypeSampleCsvUrlMap = {}, // map of filter type and sample csv download url
  validationType = "", // for CSV file validation of your choice
  maxSize, //maximum file size in MB
  acceptedFileFormat,
  noAckCall,
  action,
  addTimestampToFileName,
  serviceOwner
}) => {
  const history = useHistory();
  const [activeFile, setActiveFile] = useState("");
  const [callback_key, setCallback_key] = useState("");
  const [presign_url, setPresign_url] = useState("");
  const [csv_type, setCsvType] = useState("");
  const [file_path, setFile_path] = useState("");
  const [sample_download_url, setSampleDownloadUrl] = useState("");
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [activeFileName, setActiveFileName] = useState("");
  useEffect(() => {
    const download_url = `${
      process.env.REACT_APP_API_URL
        ? `${process.env.REACT_APP_API_URL.replace(
            variables.routeEndpoint,
            variables.sampleFileEndPoint
          )}${sampleURL}`
        : ""
    }`;

    if (sampleURL) {
      setSampleDownloadUrl(download_url);
    }
  }, []);

  const handleClose = useCallback(() => {
    if (customHandleClose) {
      customHandleClose();
      return;
    }
    if (closeUrl) {
      history.push(closeUrl);
    } else {
      history.push("/");
    }
  }, [closeUrl, customHandleClose]);

  const handleFileUploadSuccess = () => {
    if (activeFileName) {
      setUploadedFileName(activeFileName);
    }
    setActiveFilePath(file_path);
  };

  const handleSubmit = (e) => {
    setLoadingBtn(true);
    e.preventDefault();

    getUploadUrl({
      filename: activeFileName || "bulk_upload_file",
      action: action,
      file_type: activeFile.type,
      service_owner: serviceOwner
    }).then((res) => {
      setTimeout(() => setLoadingBtn(false), 3000);
      if (res) {
        setFile_path(res.file_path);
        setCallback_key(res.callback_key);
        setPresign_url(res.file_upload_url);
      } else {
        setStatus({ type: "error", message: Errors.GENERAL_ERROR });
      }
    });
  };

  const handleChange = (key, val) => {
    setCsvType(val);
    if (val === "") {
      setSampleDownloadUrl("");
      return;
    }

    const sampleCSVDownloadURL = filterTypeSampleCsvUrlMap[val];

    const download_url = `${
      process.env.REACT_APP_API_URL
        ? `${process.env.REACT_APP_API_URL.replace(
            variables.routeEndpoint,
            variables.sampleFileEndPoint
          )}${sampleCSVDownloadURL}`
        : ""
    }`;

    setSampleDownloadUrl(download_url);
  };

  const CheckIfButtonDisabled = () => {
    return activeFile === "" || (filterTypes.length > 0 && csv_type === "");
  };
  const extraParamsAckObj = useMemo(() => {
    return sendExtraAck
      ? { file_path: file_path, presign_url: presign_url, action: action, csv_type: csv_type, filename: activeFileName, file_type: activeFile.type, service_owner: serviceOwner}
      : {};
  }, [sendExtraAck, file_path, presign_url]);

  const CSVDropDown = () => {
    if (filterTypes.length > 0) {
      return (
        <PaginatedReactDropdown
          options={filterTypes}
          handleChange={handleChange}
          keyToChange="csv_type"
          placeholder="CSV Type"
          showCross={true}
          id="fileTypeDropdown"
          showPagination={false}
          value={csv_type}
        />
      );
    }
    return null;
  };

  return (
    <section>
      <NoFooterModal
        header
        heading={heading || "Bulk File Upload"}
        handleClose={handleClose}
        id={id || "bulkUploadModal"}
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid={btnDataTestID}
              disabled={CheckIfButtonDisabled()}
              onClick={handleSubmit}
              loading={loadingBtn}
              className="sushi-btn"
            >
              Confirm
            </Button>
          </BottomSectionModal>
        }
      >
        <CSVDropDown />

        <UploadCsvOption>
          <FileUpload
            title="CSV file"
            uploadUrl={uploadUrl}
            callback_key={callback_key}
            presign_url={presign_url}
            handleClose={handleClose}
            keyName={keyName || "callback_key"}
            activeFile={activeFile}
            setActiveFile={setActiveFile}
            maxSize={maxSize}
            extraParamsAckObj={extraParamsAckObj}
            acceptTypes={
              acceptedFileFormat ? acceptedFileFormat : ".csv, .xls, .xlsx"
            }
            handleFileUploadSuccess={handleFileUploadSuccess}
            validationType={validationType}
            noAckCall={noAckCall}
            action={action}
            activeFileName={activeFileName}
            setActiveFileName={setActiveFileName}
            addTimestampToFileName={addTimestampToFileName}
            useUserUploadedFilename={useUserUploadedFilename}
            serviceOwner={serviceOwner}
          />
        </UploadCsvOption>
        <NotesSection>
          <InformationBar
            sampleUrl={sample_download_url}
            instructions={instructions}
          />
        </NotesSection>
      </NoFooterModal>
    </section>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    setUploadedFileName: bindActionCreators(
      UserActions.setUploadedFileName,
      dispatch
    ),
    setActiveFilePath: bindActionCreators(
      UserActions.setActiveFilePath,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(BulkUploadFile);
